import request from '@/utils/request'

// 获取配置
export const config = (params) => {
    return request.get('/config', { params })
}

export const configBase = (params) => {
    return request.get('/config/base', { params })
}
